import React, { PureComponent } from 'react';
import { func } from 'prop-types';
import styled from 'styled-components';
import Checkbox from '@material-ui/core/Checkbox';
import { colors } from '../../../../../../../constants/colors';
import { isReminderComplete } from './util';

const Root = styled.div.withConfig({ componentId: 'sc-1mb6ao6-0' })`
  display: flex;

  & .title-checkbox {
    color: ${colors.borderLine};
  }

  & .title-checkbox-checked {
    color: ${colors.mrBlueSky};
  }
`;

const BoxToCheck = styled(Checkbox).withConfig({ componentId: 'sc-1mb6ao6-1' })`
  padding: 0 8px 0 0;
`;

const Info = styled.img.withConfig({ componentId: 'sc-1mb6ao6-2' })`
  padding: 0 8px;
  cursor: pointer;
`;

type Props = {
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  handleClick?: func;
  // @ts-expect-error ts-migrate(2749) FIXME: 'func' refers to a value, but is being used as a t... Remove this comment to see the full error message
  openInfo?: func;
  reminder?: object;
};

export default class TitleControl extends PureComponent<Props> {
  static classes = {
    root: 'title-checkbox',
    checked: 'title-checkbox-checked',
  };

  onClick = () => {
    const { handleClick } = this.props;
    handleClick(!this.checked);
  };

  get checked() {
    const { reminder } = this.props;
    return isReminderComplete(reminder);
  }

  infoClick = (e: any) => {
    e.preventDefault();
    e.stopPropagation();

    const { openInfo } = this.props;
    openInfo();
  };

  render() {
    const { children, reminder } = this.props;

    return (
      <Root onClick={this.onClick}>
        {reminder && (
          <BoxToCheck checked={this.checked} classes={TitleControl.classes} size="small" />
        )}
        {children}

        <Info alt="additional info" onClick={this.infoClick} src="/images/icons/info-grey.svg" />
      </Root>
    );
  }
}
